import React, { FC, ReactNode } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { mixins } from '../../core/styles/theme/default';

const StyledMain = styled.main(
  ({ topSpace }: { topSpace?: boolean }) => css`
    flex: 1 1 auto;
    overflow: hidden;

    ${topSpace &&
    css`
      ${mixins.responsiveStyles({
        'padding-top': { zero: 54, medium: 80 },
      })}
    `}
  `,
);

const Main: FC<MainProps> = ({
  children,
  topSpace = true,
  ...rest
}: MainProps) => (
  <StyledMain topSpace={topSpace} {...rest}>
    {children}
  </StyledMain>
);

export type MainProps = {
  children?: ReactNode;
  topSpace?: boolean;
};

export default Main;
